import { Typography } from "components/Typography";

function QuickLinks() {
  return (
    <div>
      <Typography variant="footerHeading">Home</Typography>
      <Typography variant="footerSmall">Courses</Typography>
      <Typography variant="footerSmall">About Us</Typography>
      <Typography variant="footerSmall">Contact Us</Typography>
      <Typography variant="footerSmall">Become A Contributor</Typography>
    </div>
  );
}

export default QuickLinks;
